import React, { useRef } from "react";
import { Box, Divider, Paper, Typography } from "@mui/material";
import { formatReceiptDate } from "../../../utils/formatNocDate";

const formatDate = (dateStr: string) => {
  if (!dateStr) return new Date().toLocaleDateString("en-GB");
  const date = new Date(dateStr);
  const dd = String(date.getDate()).padStart(2, "0");
  const mm = String(date.getMonth() + 1).padStart(2, "0");
  const yyyy = date.getFullYear();
  return `${dd}.${mm}.${yyyy}`;
};
function capitalizeWords(str: string) {
  if (!str) return " ";
  return str
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(" ");
}
function getAEName(applicant: any) {
  if (Array.isArray(applicant?.aeDetails)) {
    const item = applicant.aeDetails.find(
      (d: any) => d?.authority_engineer?.name,
    );
    return item?.authority_engineer?.name || "";
  }
  return applicant?.aeDetails?.authority_engineer?.name || "";
}
const PrivateLicenseContent = ({
  feeDatails,
  userData,
  applicantdata,
  roDetails,
  bgDetails,
  paDetails,
}: any) => {
  const {
    village,
    taluka,
    district,
    khasra_number,
    state,
    national_highway_number,
    application_code,
    inspectionDate,
    application_date,
    authority_name,
    address_1,
    address_2,
    pincode,
    property_type,
    start_chainage,
    end_chainage,
    chainage,
    highway_side,

    location_type_name,
    service_road_length,
    service_road_width,
  } = applicantdata || {};

  const hasValue = (value: any) =>
    value !== null && value !== undefined && value !== "";

  const chainageDisplay = hasValue(start_chainage)
    ? hasValue(end_chainage)
      ? `${start_chainage} to ${end_chainage}`
      : start_chainage
    : hasValue(chainage)
      ? chainage
      : "";

  const org = userData?.organizations?.[0];

  return (
    <Box
      className="pdf-document"
      sx={{
        fontFamily: "Trebuchet MS, Arial, sans-serif",
        fontSize: 18,
        color: "#000",
        p: 0,
        m: 0,
        width: "100%",
        overflow: "visible",
        height: "auto",

        "& *": {
          fontFamily: "Trebuchet MS, Arial, sans-serif",
          boxSizing: "border-box",
        },

        "@media print": {
          fontSize: "18px",
          lineHeight: 1.45,
          width: "100%",
          overflow: "visible",
        },
      }}
    >
      <Box
        sx={{
          p: { xs: 1, md: 4 },
          width: "100%",
          maxWidth: "100%",
          margin: "0 auto",
          textAlign: "justify",
          overflow: "visible",

          "@media print": {
            padding: "8mm 10mm",
            width: "100%",
            maxWidth: "100%",
          },
        }}
      >
        <Paper
          elevation={2}
          sx={{
            p: { xs: 1, md: 4 },
            borderRadius: 3,
            height: "auto",
            minHeight: 0,
            overflow: "visible",

            "@media print": {
              boxShadow: "none",
              borderRadius: 0,
              padding: 0,
              margin: 0,
              height: "auto",
              minHeight: 0,
              overflow: "visible",

              breakInside: "auto",
              pageBreakInside: "auto",
            },
          }}
        >
          {/* Header */}
          <img
            src={require("@assets/images/national-emblem.png")}
            alt="National Emblem"
            style={{
              display: "block",
              margin: "0 auto",
              width: 60,
              height: "auto",
              // marginBottom: 16
            }}
          />
          <Typography
            variant="h6"
            fontWeight={700}
            align="center"
            sx={{
              mb: 1,
              fontFamily: "Trebuchet MS, Arial, sans-serif !important",
              fontSize: "inherit",
            }}
          >
            Government of India
          </Typography>
          <Typography
            align="center"
            sx={{
              fontWeight: 500,
              fontFamily: "Trebuchet MS, Arial, sans-serif !important",
              fontSize: "inherit",
            }}
          >
            Ministry of Road Transport & Highways
          </Typography>
          <Typography
            align="center"
            sx={{
              fontWeight: 500,
              fontFamily: "Trebuchet MS, Arial, sans-serif !important",
              fontSize: "inherit",
            }}
          >
            Regional Office - {roDetails?.office_name}
          </Typography>
          <Typography
            align="center"
            sx={{
              fontWeight: 400,
              fontSize: "inherit",
              fontFamily: "Trebuchet MS, Arial, sans-serif !important",
            }}
          >
            {roDetails?.address_line1}
            {/* {roDetails.address_line2 || "____"} */}
          </Typography>
          {/* <Typography align="center" sx={{ fontWeight: 400, fontSize: 14 }}>
            Phone No. {roDetails?.contact_number || "____"} ,{" "}
            <mark>Phone/Fax No. +1 2125556254</mark>, Email-
            {roDetails?.email ? (
              <a href={`mailto:${roDetails.email}`}>{roDetails.email}</a>
            ) : (
              "____"
            )}
          </Typography> */}
          <Divider sx={{ my: 2 }} />
          {/* Title and Application Info */}
          <Typography
            variant="h6"
            fontWeight={700}
            sx={{
              mb: 1,
              textDecoration: "underline",
              textAlign: { xs: "right", md: "right" },
              fontFamily: "Trebuchet MS, Arial, sans-serif !important",
              fontSize: "inherit",
            }}
          >
            PROVISIONAL NOC
          </Typography>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              mb: 1,
              fontSize: "inherit",
              fontFamily: "Trebuchet MS, Arial, sans-serif !important",
            }}
          >
            <Typography
              sx={{
                fontSize: "inherit",
                fontFamily: "Trebuchet MS, Arial, sans-serif !important",
              }}
            >
              Application No.: <b>{application_code || "_____"}</b>
            </Typography>
            {/* <Typography
              sx={{
                fontSize: "inherit",
                fontFamily: "Trebuchet MS, Arial, sans-serif !important",
              }}
            >
              Dated: <b>{formatDate(new Date().toISOString())}</b>
            </Typography> */}
          </Box>
          {/* To Section */}
          <Typography
            sx={{
              mb: 1,
              fontSize: "inherit",
              fontFamily: "Trebuchet MS, Arial, sans-serif !important",
            }}
          >
            To,
            <br />
            {userData?.name || "_____"},<br />
            {applicantdata?.organizations?.[0]?.business_name
              ? org?.pincode
              : ""}
            {userData?.address || ""}
            <br />
            {applicantdata?.organizations?.[0]?.business_name || null}
            <br />
            {applicantdata?.organizations?.[0]?.business_name ? (
              <>
                {org?.city_name}, {org?.district_name}, {org?.state_name}
                <br />
              </>
            ) : null}
          </Typography>
          {/* Subject */}
          <Typography
            sx={{
              mb: 2,
              fontSize: "inherit",
              fontFamily: "Trebuchet MS, Arial, sans-serif !important",
            }}
          >
            <b>Subject:</b> Access application for proposed{" "}
            <b>{property_type || "__"}</b> abutting &nbsp;
            <b>{national_highway_number || "____"}</b> at km{" "}
            <b>{chainageDisplay}</b> (<b>{highway_side || "____"}</b>), Khasra
            No./Block No./ Gat No./Survey No. <b>{khasra_number || "____"}</b>,
            Village/Town <b>{village || "____"}</b>, Taluka
            <b> {taluka || "__"}</b>, District <b>{district || "____"}</b> in
            the State / UT of <b>{state || "____"}</b>: regarding issue of
            Provisional NOC.
          </Typography>
          {/* Fees Details */}

          {/* <Typography sx={{ mb: 2, fontSize: 13 }}>
            <b>Fees Details:</b>
            <br />
            {feeDatails?.length > 0 &&
              feeDatails.map((allfee: any, index: number) => (
                <div>
                  (i) Processing fees of Rs.
                  <b>{allfee?.fees?.netAmount} </b>
                  (TRN no. <b>{allfee.transactionId}</b> dated{" "}
                  <b> {formatDate(allfee.transactionDate)})</b>
                  <div>
                    (ii) Processing fees of Rs.20,000.00 (TRN no.
                    XXXXXXXXXXXXXXX dated XX.XX.20XX)
                  </div>
                  <div>
                    (iii) Bank Guarantee: bearing No.{" "}
                    <b>{bgDetails?.bank_guarantee_no || "___"}</b> issued by{" "}
                    <b>{bgDetails?.bg_bank_name || "___"} </b> Bank on{" "}
                    <b>{formatDate(bgDetails?.bg_isssue_date) || "___"}</b>{" "}
                    valid till{" "}
                    <b>{formatDate(bgDetails?.bg_validity_date) || "___"}</b>
                  </div>
                </div>
              ))}
            (3) Bank Guarantee: bearing No.{" "}
            <b>{bgDetails?.bank_guarantee_no || "___"}</b> issued by{" "}
            <b>{bgDetails?.bg_bank_name || "___"} </b> Bank on{" "}
            <b>{formatDate(bgDetails?.bg_isssue_date) || "___"}</b> valid till{" "}
            <b>{formatDate(bgDetails?.bg_validity_date) || "___"}</b>
          </Typography> */}

          {/* <Typography sx={{ mb: 2 }}>
                      <b>Fees Details:</b>
                      <br />
                      {feeDatails?.length > 0 &&
                        feeDatails?.map((allfee: any, index: number) => (
                          <div key={index} >
                            ({index + 1}) Processing fees of Rs.
                            {allfee?.fees?.netAmount} (TRN no. {allfee.transactionId}{" "}
                            dated {formatDate(allfee.transactionDate)})
                          </div>
                        ))}
                      (4) Bank Guarantee: bearing No.{" "}
                      <b>{bgDetails?.bank_guarantee_no || "___"}</b> issued by{" "}
                      <b>{bgDetails?.bg_bank_name || "___"} </b> Bank on{" "}
                      <b>{formatDate(bgDetails?.bg_isssue_date) || "___"}</b> valid till{" "}
                      <b>{formatDate(bgDetails?.bg_validity_date) || "___"}</b>
                    </Typography> */}

          <Typography
            sx={{
              mb: 2,
              fontSize: "inherit",
              fontFamily: "Trebuchet MS, Arial, sans-serif !important",
            }}
          >
            <b>Fees Details:</b>
            <Box
              component="ol"
              type="i"
              sx={{
                pl: 3,
                mb: 2,
                fontSize: "inherit",
                fontFamily: "Trebuchet MS, Arial, sans-serif !important",

                "& li": {
                  lineHeight: 1.45,
                  marginBottom: "4px",
                  overflowWrap: "break-word",
                  wordBreak: "normal",

                  // Important for PDF
                  breakInside: "auto",
                  pageBreakInside: "auto",
                },
              }}
            >
              {feeDatails?.length > 0 &&
                feeDatails?.map((allfee: any, index: number) => (
                  <li key={index}>
                    Processing fees of Rs. <b>{allfee?.fees?.netAmount}</b> (TRN
                    no. <b>{allfee.transactionId}</b> dated{" "}
                    <b>
                      {allfee?.transactionDate &&
                        formatDate(allfee?.transactionDate)}
                    </b>
                    )
                  </li>
                ))}
              <li>
                Bank Guarantee: bearing No.{" "}
                <b>{bgDetails?.bank_guarantee_no || "___"}</b> issued by{" "}
                <b>{bgDetails?.bg_bank_name || "___"}</b> Bank on{" "}
                <b>{formatDate(bgDetails?.bg_isssue_date) || "___"}</b> valid
                till <b>{formatDate(bgDetails?.bg_validity_date) || "___"}</b>
              </li>
            </Box>
          </Typography>

          {/* Body */}
          <Typography
            sx={{
              mb: 2,
              fontSize: "inherit",
              fontFamily: "Trebuchet MS, Arial, sans-serif !important",
            }}
          >
            Respected Sir/Mam,
            <br />
            &nbsp;&nbsp;&nbsp;&nbsp;Please refer to your online proposal dated{" "}
            <b>{formatDate(application_date)}</b> submitted on Ministry’s
            website on {/* {application_date?.slice(0, 10) || "xx.xx.20xxx"} */}
            <b>{formatDate(application_date)}</b> for access permission on the
            subject mentioned above.
            <br />
            2.{" "}
            <b>
              {capitalizeWords(
                applicantdata?.aeDetails?.[0]?.authority_engineer?.name ??
                  applicantdata?.aeDetails?.authority_engineer?.name ??
                  "Authority Engineer",
              )}
            </b>
            {" - "}
            <b>
              {Array.isArray(applicantdata?.aeDetails)
                ? (applicantdata?.aeDetails?.[0]?.ae_agency ?? "AE Agency")
                : (applicantdata?.aeDetails?.ae_agency ?? "AE Agency")}
            </b>
            /{" "}
            {Array.isArray(paDetails) && paDetails.length > 0 && (
              <b>{paDetails.map((pa: any) => pa.office_name).join(" / ")}</b>
            )}{" "}
            {" - "}
            <b>
              {paDetails?.map((pa: any) => pa?.authority)?.join(" / ")}
            </b>{" "}
            vide inspection report dated{" "}
            <b>{formatDate(inspectionDate) || "NA"}</b> has submitted the
            inspection report for the access permission for subject mentioned
            Private property/Other establishments and recommended for access
            permission.
            <br />
            3. The case has been accepted in-principle by this office as per{" "}
            <b>{location_type_name || "____"}</b> reach norms based on
            recommendation of{" "}
            {Array.isArray(paDetails) && paDetails.length > 0 && (
              <b>{paDetails.map((pa: any) => pa.office_name).join(" / ")}</b>
            )}{" "}
            {" - "}
            <b>
              {paDetails?.map((pa: any) => pa?.authority)?.join(" / ")}
            </b>{" "}
            which is valid upto one year from the date of issue of this letter,
            subject to the following general conditions:
          </Typography>
          {/* General Conditions */}
          <Box
            component="ol"
            type="i"
            sx={{
              pl: 3,
              mb: 2,
              fontSize: "inherit",
              fontFamily: "Trebuchet MS, Arial, sans-serif !important",
            }}
          >
            <li>
              The instant approval is based on the submissions made by the
              applicant as verified by the{" "}
              <b>
                {capitalizeWords(
                  applicantdata?.aeDetails?.[0]?.authority_engineer?.name
                    ? applicantdata?.aeDetails?.[0]?.authority_engineer?.name
                    : (applicantdata?.aeDetails?.authority_engineer?.name ??
                        "Authority Engineer"),
                )}
              </b>{" "}
              {" - "}
              <b>
                {Array.isArray(applicantdata?.aeDetails)
                  ? (applicantdata?.aeDetails?.[0]?.ae_agency ?? "AE Agency")
                  : (applicantdata?.aeDetails?.ae_agency ?? "AE Agency")}
              </b>
              /{" "}
              {Array.isArray(paDetails) && paDetails.length > 0 && (
                <b>{paDetails.map((pa: any) => pa.office_name).join(" / ")}</b>
              )}{" "}
              {" - "}
              <b>{paDetails?.map((pa: any) => pa?.authority)?.join(" / ")}</b> .
              The Applicant is responsible for the details provided in the
              application. Any misrepresentations, omission or suppression of
              facts or disclosure of incomplete facts detected at any stage
              shall lead to withdrawal of this approval with cost to the
              applicant.
            </li>
            <li>
              The applicant may construct the access to the proposed site, as
              per approved drawings at their own cost within 12 months of the
              issue of this Provisional NOC.
            </li>
            <li>
              In case the construction is not done in one year of the issue of
              this provisional NOC, the same shall be deemed to be cancelled,
              unless renewed by the Competent Authority.
            </li>
            <li>
              The Provisional NOC shall be valid only upon the successful
              realization of the requisite fee as per para 2.11 of the MoRTH
              Circular no. RW/NH-33032/01/2017-S&R(R) dated 26.06.2020 to the
              Central Government Account through Bharatkosh Portal.
            </li>
            <li>
              The issue of final formal permission including issuance of signed
              license deed would be subject to the certification by the{" "}
              <b>
                {capitalizeWords(
                  applicantdata?.aeDetails?.[0]?.authority_engineer?.name ??
                    applicantdata?.aeDetails?.authority_engineer?.name ??
                    "Authority Engineer",
                )}
              </b>
              {" - "}
              <b>
                {Array.isArray(applicantdata?.aeDetails)
                  ? (applicantdata?.aeDetails?.[0]?.ae_agency ?? "AE Agency")
                  : (applicantdata?.aeDetails?.ae_agency ?? "AE Agency")}
              </b>
              /{" "}
              {Array.isArray(paDetails) && paDetails.length > 0 && (
                <b>{paDetails.map((pa: any) => pa.office_name).join(" / ")}</b>
              )}{" "}
              {" - "}
              <b>
                {paDetails?.map((pa: any) => pa?.authority)?.join(" / ")}
              </b>{" "}
              that the constructions have been carried out by owner in
              compliance with the provisions approved by this officer as per
              approved layout/location plan and as per Ministry’s guidelines
              issued vide circular No. RW/NH-33032/01/2017-S&R(R) dated
              26.06.2020. Hence it is directed to submit the detailed compliance
              report of this Provisional NOC along with completion certificate
              after construction of access road as per approved layout/location
              plan from the{" "}
              <b>
                {capitalizeWords(
                  applicantdata?.aeDetails?.[0]?.authority_engineer?.name ??
                    applicantdata?.aeDetails?.authority_engineer?.name ??
                    "Authority Engineer",
                )}
              </b>
              {" - "}
              <b>
                {Array.isArray(applicantdata?.aeDetails)
                  ? (applicantdata?.aeDetails?.[0]?.ae_agency ?? "AE Agency")
                  : (applicantdata?.aeDetails?.ae_agency ?? "AE Agency")}
              </b>
              /
              {Array.isArray(paDetails) && paDetails.length > 0 && (
                <b>{paDetails.map((pa: any) => pa.office_name).join(" / ")}</b>
              )}
              {" - "}
              <b>
                {paDetails?.map((pa: any) => pa?.authority)?.join(" / ")}
              </b>{" "}
              for execution of license deed at the time of Final NOC.
            </li>
            <li>
              If the access is taken without the final approval/signing of
              licensee deed from the Highway Administration, necessary action as
              per para. 2.11 of MoRTH circular No. RW/NH-33032/01/2017-S&R(R)
              dated 26.06.2020 may be taken under which a penalty of Rs.
              2,50,000.00 shall be imposed on the applicant to regularize such
              application.
            </li>
            <li>
              In the event of any comments or shortcomings are pointed by this
              office in due course of time even after issue of NOC/final
              approval, same shall be incorporated in drawing/layout plan and
              shall be rectified by the applicant as per clause 2.7 and clause
              11.0 of Ministry’s letter No. RW/NH-33032/01/2017-S&R(R) dated
              26.06.2020.
            </li>
            <li>Deleted.</li>
            <li>
              The requisite clearances from concerned department for tree
              cutting and shifting of roadside utilities like electric line,
              water/sewer pipeline/canal shall be obtained by the applicant if
              any required at his own cost for construction of service road as
              per approved drawing and applicant shall solemnly responsible for
              the same.
            </li>
            <li>
              Height restrictions of building structure shall be as per local
              Govt. guidelines and there should be sufficient parking inside so
              that there is no overflow of vehicles on approach road.
            </li>
            <li>
              Minimum desirable standards for control line and building line
              from center of Project Highway to preserve sufficient space for
              road as per applicability under Ribbon Development, Fire
              department and other Authorities Rules and Regulations to be
              followed.
            </li>
          </Box>
          <br />
          <br />
          <Typography
            sx={{
              fontFamily: "Trebuchet MS, Arial, sans-serif !important",
              fontSize: "inherit",
              lineHeight: 1.85,

              breakInside: "avoid",
              pageBreakInside: "avoid",
            }}
          >
            4. The compliance of the following Special conditions of the ‘In-
            principle’ approval shall be ensured and submitted at the time of
            Final NOC:
          </Typography>
          <Box sx={{ height: "12px" }} />
          <Typography
            sx={{
              mb: 1,
              fontSize: "inherit",
              fontFamily: "Trebuchet MS, Arial, sans-serif !important",
            }}
          >
            <b>Special Conditions of Approval:</b>
          </Typography>
          <Box
            component="div"
            sx={{
              pl: 0,
              mb: 2,
              fontSize: "inherit",
              fontFamily: "Trebuchet MS, Arial, sans-serif !important",
              lineHeight: 1.45,
              overflowWrap: "break-word",
              wordBreak: "normal",

              breakInside: "auto",
              pageBreakInside: "auto",
            }}
          >
            {applicantdata?.ca_provisional_remarks?.comments} at{" "}
            {formatDate(applicantdata?.ca_provisional_remarks?.created_at)}
          </Box>

          {/* Special Conditions */}
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              width: "100%",
              marginTop: "2rem",
              marginBottom: "2rem",
            }}
          >
            <Box
              sx={{
                display: "flex",
                justifyContent: "flex-end",
                width: "100%",
                marginTop: "24px",
                marginBottom: "20px",

                // Keep signature together
                breakInside: "avoid",
                pageBreakInside: "avoid",
              }}
            >
              <Box
                sx={{
                  textAlign: "right",
                  maxWidth: "100%",
                  overflowWrap: "break-word",
                }}
              >
                <Typography
                  sx={{
                    mb: 1,
                    fontSize: "inherit",
                    fontFamily: "Trebuchet MS, Arial, sans-serif !important",
                  }}
                  align="right"
                >
                  Yours faithfully,
                </Typography>

                <Typography
                  sx={{
                    fontWeight: 700,
                    fontFamily: "Trebuchet MS, Arial, sans-serif !important",
                    fontSize: "inherit",
                    lineHeight: 1.45,
                  }}
                  align="right"
                >
                  {roDetails?.ro_name} - {roDetails?.office_name || "____"} -{" "}
                  {applicantdata?.ca_authority}
                  <br />
                  For Highway Administration
                  <br />
                  (Digitally signed)
                </Typography>
              </Box>
            </Box>
          </div>
          <div style={{ textAlign: "left" }}>
            <Typography
              sx={{
                mb: 1,
                fontSize: "inherit",
                fontFamily: "Trebuchet MS, Arial, sans-serif !important",
              }}
            >
              Encl: Digitally signed layout plan
            </Typography>
          </div>
          <Divider
            sx={{
              my: 2,
              fontSize: "inherit",
              fontFamily: "Trebuchet MS, Arial, sans-serif !important",
            }}
          />
          <Typography
            sx={{
              mb: 1,
              fontSize: "inherit",
              fontFamily: "Trebuchet MS, Arial, sans-serif !important",
            }}
          >
            <b>Copy to:</b>
            <br />
            1.{" "}
            {Array.isArray(paDetails) && paDetails.length > 0 && (
              <b>{paDetails.map((pa: any) => pa.office_name).join(" / ")}</b>
            )}{" "}
            {applicantdata?.is_legacy ? (
              <span>for information and necessary actions.</span>
            ) : (
              <>
                With request to keep original Bank guarantee vide BG no:{" "}
                <b>{bgDetails?.bank_guarantee_no || "___"}</b> dated{" "}
                <b>{formatDate(bgDetails?.bg_isssue_date || "___")}</b> valid up
                to <b>{formatDate(bgDetails?.bg_validity_date || "___")}</b>{" "}
                from bank <b>{bgDetails?.bg_bank_name || "___"} </b> in your
                safe custody.
              </>
            )}
          </Typography>
        </Paper>
      </Box>
    </Box>
  );
};

export default PrivateLicenseContent;
